import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export function PrivacyModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[80vh] overflow-y-auto bg-gray-900 border-gray-700" data-testid="privacy-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">Política de Privacidad</DialogTitle>
        </DialogHeader>
        <div className="mt-4 text-gray-300 text-sm space-y-6 leading-relaxed">
          <p className="text-gray-400">Última actualización: 3 de abril de 2026</p>
          
          <div>
            <h3 className="text-white font-bold mb-2">1. Información que Recopilamos</h3>
            <p>Recopilamos información que nos proporcionas directamente cuando utilizas nuestra plataforma:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>Información de contacto:</strong> Nombre, correo electrónico, teléfono, cargo</li>
              <li><strong>Información de la clínica:</strong> Nombre, ubicación, número de centros</li>
              <li><strong>Información sobre uso de IA:</strong> Herramientas utilizadas, áreas de aplicación</li>
              <li><strong>Datos técnicos:</strong> Dirección IP, navegador, dispositivo, cookies</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">2. Cómo Utilizamos tu Información</h3>
            <ul className="list-disc pl-5 space-y-1">
              <li>Gestionar y responder a solicitudes de diagnóstico</li>
              <li>Proporcionar servicios de auditoría legal de IA</li>
              <li>Enviar comunicaciones relevantes sobre nuestros servicios</li>
              <li>Cumplir con obligaciones legales (EU AI Act, RGPD, AEPD)</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">3. Base Legal para el Procesamiento (RGPD)</h3>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Consentimiento (Art. 6(1)(a)):</strong> Para marketing y comunicaciones</li>
              <li><strong>Ejecución de contrato (Art. 6(1)(b)):</strong> Para proporcionar nuestros servicios</li>
              <li><strong>Interés legítimo (Art. 6(1)(f)):</strong> Para mejorar la seguridad</li>
              <li><strong>Obligación legal (Art. 6(1)(c)):</strong> Para cumplir con normativa aplicable</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">4. Retención de Datos</h3>
            <ul className="list-disc pl-5 space-y-1">
              <li>Solicitudes de diagnóstico: Mientras exista relación comercial</li>
              <li>Leads: 90 días si no hay conversión</li>
              <li>Logs de auditoría: 1 año (cumplimiento legal)</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">5. Tus Derechos (RGPD)</h3>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Derecho de acceso (Art. 15):</strong> Solicitar una copia de tus datos</li>
              <li><strong>Derecho de rectificación (Art. 16):</strong> Corregir datos inexactos</li>
              <li><strong>Derecho al olvido (Art. 17):</strong> Solicitar la eliminación de tus datos</li>
              <li><strong>Derecho a la portabilidad (Art. 20):</strong> Recibir tus datos en formato estructurado</li>
              <li><strong>Derecho de oposición (Art. 21):</strong> Oponerte al procesamiento</li>
            </ul>
            <p className="mt-2">Para ejercer estos derechos, contacta a: <strong className="text-blue-400">info@tecnoabogado.com</strong></p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">6. Cumplimiento AEPD (España)</h3>
            <p>Estamos registrados como responsable de tratamiento ante la Agencia Española de Protección de Datos (AEPD). En caso de brecha de datos, notificaremos a la AEPD en menos de 72 horas.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">7. Contacto</h3>
            <p><strong>Responsable:</strong> José Luis Vilaplana (@tecnoabogado)</p>
            <p><strong>Email:</strong> info@tecnoabogado.com</p>
            <p><strong>Autoridad de control:</strong> Agencia Española de Protección de Datos (AEPD) - sedeagpd.gob.es</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function AiTransparencyModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[80vh] overflow-y-auto bg-gray-900 border-gray-700" data-testid="ai-transparency-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">Transparencia IA (EU AI Act)</DialogTitle>
        </DialogHeader>
        <div className="mt-4 text-gray-300 text-sm space-y-6 leading-relaxed">
          <p className="text-gray-400">Cumplimiento: RGPD, EU AI Act (Art. 50), AEPD España</p>
          
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
            <h3 className="text-blue-400 font-bold mb-2">Aviso Obligatorio (EU AI Act Art. 50)</h3>
            <p>Esta plataforma utiliza sistemas de inteligencia artificial. Según el Reglamento (UE) 2024/1689 (EU AI Act), debemos informarte claramente sobre el uso de IA y sus limitaciones.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">1. Sistemas de IA Utilizados</h3>
            <p>La plataforma puede utilizar los siguientes modelos de IA para procesamiento de solicitudes y comunicaciones:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Modelos de lenguaje para análisis de texto</li>
              <li>Sistemas de automatización de email</li>
            </ul>
            <p className="mt-2 text-yellow-400/80"><strong>Clasificación de riesgo:</strong> Riesgo Bajo según EU AI Act - Uso administrativo y de comunicación</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">2. Capacidades y Limitaciones</h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <p className="text-green-400 font-semibold mb-2">✓ Puede hacer:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Procesar formularios de solicitud</li>
                  <li>Enviar notificaciones automatizadas</li>
                  <li>Organizar información de contacto</li>
                </ul>
              </div>
              <div>
                <p className="text-red-400 font-semibold mb-2">✗ NO puede hacer:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Proporcionar asesoramiento legal definitivo</li>
                  <li>Tomar decisiones sin supervisión humana</li>
                  <li>Reemplazar la consulta con profesionales</li>
                </ul>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">3. Riesgos y Consideraciones</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Supervisión humana:</strong> Todas las auditorías y diagnósticos son realizados por profesionales humanos especializados en derecho tecnológico.</li>
              <li><strong>Privacidad:</strong> Los datos se procesan conforme al RGPD. Lee nuestra Política de Privacidad para más detalles.</li>
              <li><strong>Limitaciones:</strong> La IA solo se usa para tareas administrativas, nunca para asesoramiento legal.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">4. Cumplimiento Legal</h3>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>EU AI Act (Reglamento (UE) 2024/1689):</strong> Art. 50 - Transparencia</li>
              <li><strong>RGPD (Reglamento (UE) 2016/679):</strong> Consentimiento y protección de datos</li>
              <li><strong>AEPD (España):</strong> Registrados como responsable de tratamiento</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">5. Reportar Problemas</h3>
            <p>Si encuentras información incorrecta, sesgo, o cualquier problema relacionado con el uso de IA, por favor repórtalo a: <strong className="text-blue-400">info@tecnoabogado.com</strong></p>
          </div>

          <p className="text-gray-500 text-xs">Última actualización: Enero 2026</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function LegalNoticeModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[80vh] overflow-y-auto bg-gray-900 border-gray-700" data-testid="legal-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">Aviso Legal</DialogTitle>
        </DialogHeader>
        <div className="mt-4 text-gray-300 text-sm space-y-6 leading-relaxed">
          <div>
            <h3 className="text-white font-bold mb-2">1. Identificación del Responsable</h3>
            <ul className="space-y-1">
              <li><strong>Denominación:</strong> IA Sanitaria</li>
              <li><strong>Responsable:</strong> José Luis Vilaplana (@tecnoabogado)</li>
              <li><strong>Email:</strong> info@tecnoabogado.com</li>
              <li><strong>Sitio web:</strong> www.iasanitaria.es</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">2. Objeto y Ámbito de Aplicación</h3>
            <p>Este aviso legal regula el uso del sitio web www.iasanitaria.es, dedicado a ofrecer información y servicios de auditoría legal sobre el uso de inteligencia artificial en clínicas de medicina estética.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">3. Condiciones de Uso</h3>
            <p>El acceso a este sitio web es gratuito y no requiere registro previo. El usuario se compromete a:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Hacer un uso adecuado de los contenidos y servicios</li>
              <li>No realizar actividades ilícitas o contrarias a la buena fe</li>
              <li>No difundir contenidos que dañen los derechos de terceros</li>
              <li>No introducir virus informáticos o realizar acciones que dañen los sistemas</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">4. Propiedad Intelectual</h3>
            <p>Todos los contenidos del sitio web (textos, imágenes, diseño, código fuente, logotipos, marcas) son propiedad de IA Sanitaria o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">5. Exclusión de Responsabilidad</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Información:</strong> La información proporcionada tiene carácter orientativo y no constituye asesoramiento jurídico profesional.</li>
              <li><strong>Disponibilidad:</strong> No garantizamos la disponibilidad continua del sitio web.</li>
              <li><strong>Enlaces externos:</strong> No nos responsabilizamos del contenido de sitios web enlazados.</li>
              <li><strong>Formularios:</strong> La cumplimentación del formulario de diagnóstico no constituye por sí misma una relación contractual ni asesoramiento jurídico.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">6. Normativa Aplicable</h3>
            <p>Este sitio web se rige por la legislación española y europea, incluyendo:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Reglamento (UE) 2016/679 (RGPD)</li>
              <li>Ley Orgánica 3/2018 (LOPDGDD)</li>
              <li>Reglamento (UE) 2024/1689 (AI Act)</li>
              <li>Ley 34/2002 (LSSI-CE)</li>
              <li>Ley 41/2002 de autonomía del paciente</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">7. Jurisdicción</h3>
            <p>Para cualquier controversia derivada del uso de este sitio web, serán competentes los Juzgados y Tribunales de la ciudad del domicilio del responsable, salvo que la normativa aplicable establezca otra cosa.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">8. Contacto</h3>
            <p>Para cualquier consulta relacionada con este aviso legal, puede contactar con nosotros en: <strong className="text-blue-400">info@tecnoabogado.com</strong></p>
          </div>

          <p className="text-gray-500 text-xs">Última actualización: Abril 2026</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function CookiePolicyModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl max-h-[80vh] overflow-y-auto bg-gray-900 border-gray-700" data-testid="cookie-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">Política de Cookies</DialogTitle>
        </DialogHeader>
        <div className="mt-4 text-gray-300 text-sm space-y-6 leading-relaxed">
          <p className="text-gray-400">Última actualización: Febrero 2026</p>

          <div>
            <h3 className="text-white font-bold mb-2">1. ¿Qué son las cookies?</h3>
            <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Permiten recordar preferencias, analizar el uso del sitio y mejorar la experiencia de navegación.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">2. Cookies que utilizamos</h3>
            <div className="space-y-3">
              <div className="p-3 rounded-lg bg-gray-800/50 border border-gray-700">
                <p className="text-white font-semibold text-sm">Cookies necesarias (siempre activas)</p>
                <p className="text-gray-400 text-xs mt-1">Imprescindibles para el funcionamiento del sitio. Incluyen la preferencia de cookies y funcionalidad básica del formulario.</p>
              </div>
              <div className="p-3 rounded-lg bg-gray-800/50 border border-gray-700">
                <p className="text-white font-semibold text-sm">Cookies analíticas (opcionales)</p>
                <p className="text-gray-400 text-xs mt-1">Nos ayudan a entender cómo los visitantes interactúan con el sitio web, recopilando información de forma anónima.</p>
              </div>
              <div className="p-3 rounded-lg bg-gray-800/50 border border-gray-700">
                <p className="text-white font-semibold text-sm">Cookies de marketing (opcionales)</p>
                <p className="text-gray-400 text-xs mt-1">Permiten mostrar contenido y publicidad relevante basada en tus intereses.</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">3. Cómo gestionar las cookies</h3>
            <p>Puedes configurar tus preferencias de cookies en cualquier momento a través del banner de cookies que aparece en la parte inferior de la página, o desde la configuración de tu navegador.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">4. Base legal</h3>
            <p>El uso de cookies se rige por el <strong className="text-white">RGPD (Reglamento UE 2016/679)</strong>, la <strong className="text-white">LOPDGDD</strong> y la <strong className="text-white">Ley 34/2002 de servicios de la sociedad de la información (LSSI-CE)</strong>.</p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-2">5. Contacto</h3>
            <p>Para cualquier consulta sobre nuestra política de cookies: <strong className="text-blue-400">info@tecnoabogado.com</strong></p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
